import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-agenda-item',
    templateUrl: './agenda-item.component.html',
    imports: [CommonModule,],
    styleUrls: ['./agenda-item.component.css']
})
export class AgendaItemComponent {
  @Input('myColor1') myColor1:any;
  @Input('myColor2') myColor2:any;
  @Input('data') data:any;


 hexToRgb(hex:any) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
}
